
const GraphQLMutation = require('app/graphql/Mutation');
const Modal = require('app/ui/Modal');

class SendModal {

    defaultOptions() {
        return {
            'invoice': null,
            'title': '',
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmit = this.onSubmit.bind(this);

        this.invoice = this.settings.invoice;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.modal = new Modal({
            'title': window.translate('app.billing.invoice.send.title',{'%reference%':this.invoice.reference}),
            'modalSize': 'xl',
            'showFooter': false,
            'content': this.buildForm()
        });

        this.modal.show();
    }

    getEmail(){
        let email = this.invoice.customer ? this.invoice.customer.email : '';
        if(email == '' && this.invoice.customer.restaurantAssociations){
            for(var i in this.invoice.customer.restaurantAssociations){
                let restaurantAssociation = this.invoice.customer.restaurantAssociations[i];
                if(restaurantAssociation.restaurant.email){
                    email = restaurantAssociation.restaurant.email;
                }
            }
        }
        return email;
    }

    buildForm(){
        this.$form = $('<form/>')
        .attr('method','POST')
        //.attr('action',window.App.get('oldAdminHomeUrl')+'/ajax_post/ajax_post/simple')
        .addClass('billing-invoice-send-form')
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','a')
            .val('billing_sendInvoice')
        )
        .append(
            $('<input/>')
            .attr('type','hidden')
            .attr('name','id')
            .val(this.invoice.id)
        )

        let email = this.getEmail();
        this.$inputEmail = $('<input/>')
        .attr('type','text')
        .attr('name','email')
        .attr('required','required')
        .addClass('form-control')
        .val(email);
        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .append(window.translate('app.billing.invoice.send.email.label'))
            )
            .append(this.$inputEmail)
        );


        let min = moment().add(1, 'day').format('YYYY-MM-DD');
        this.$inputLevy = $('<input/>')
        .attr('type','date')
        .attr('name','levy')
        .attr('required','required')
        .attr('min',min)
        .addClass('form-control');

        this.$form
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .append(window.translate('app.billing.invoice.send.levy.label'))
            )
            .append(this.$inputLevy)
        );


        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success')
        .append(
            $('<i/>')
            .addClass('fas fa-envelope me-1')
        )
        .append(window.translate('app.billing.invoice.send.submit.label'));


        this.$form
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-4')
            .append(this.$btnSubmit)
        )

        this.$form.on('submit',this.onSubmit);

        return this.$form;
    }

    onSubmit(event){
        var self = this;
        event.preventDefault();
        event.stopPropagation();

        let oldHtml = this.$btnSubmit.html();

        this.$btnSubmit
        .attr('disabled','disabled')
        .html('')
        .append(
            $('<i/>')
            .addClass('fa fa-spin fa-spinner me-1')
        )
        .append(window.translate('emailSending'));


        let mutation = new GraphQLMutation({
            'mutationType': "SendBillingInvoice",
            'fields': [
                'success',
                'message',
            ],
            'variables': {
                'id': {
                    'value': this.invoice.id,
                    'type': "Int!"
                },
                'to': {
                    'value': this.$inputEmail.val(),
                    'type': "String!"
                },
                'levy': {
                    'value': this.$inputLevy.val(),
                    'type': "Date!"
                }
            },
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    window.notify(window.translate('emailSent'),'success');
                    self.dispose();
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                self.$btnSubmit
                .removeAttr('disabled')
                .html(oldHtml);
            }
        });

        mutation.execute();

        //$.ajax({
        //    'method': this.$form.attr('method'),
        //    'url': this.$form.attr('action'),
        //    'data': {
        //        'id': this.invoice.id,
        //        'a': 'billing_sendInvoice',
        //        'email': this.$inputEmail.val(),
        //        'datePrelevement': this.$inputLevy.val(),
        //    }
        //})
        // .always(function(){
        //    window.notify(window.translate('emailSent'),'success');
        //    self.dispose();
        //    self.$btnSubmit
        //    .removeAttr('disabled')
        //    .html(oldHtml);
        //})
    }

    dispose(){
        this.modal.dispose();
    }

}

module.exports = SendModal;